import React, { Fragment, useCallback, useMemo } from "react";
import "./styles.css";
import { useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import { ReactComponent as SpoonIcon } from "common/assets/svg/spoons-icon.svg";
import { ReactComponent as SearchIconV2 } from "common/assets/svg/search-icon.svg";
import { ReactComponent as ShoppingCartIcon } from "common/assets/svg/shopping-cart-icon.svg";
import { ReactComponent as BakeIcon } from "common/assets/svg/bake-icon.svg";
import { MenuOptionType } from "common/features/navigation/navigationModels";
import { CartItem } from "common/features/cart/cartModels";

interface BottomNavigationProps {
  handleCallBack: (option: MenuOptionType) => void;
}

const BottomNavigation = (props: BottomNavigationProps) => {
  const currentSelectedMenuOption = useSelector(
    (state: RootState) => state.navigation.currentMenuOption
  );

  const cartItemsCount = useSelector((state: RootState) =>
    state.cart.cart.items.reduce(
      (accumulator: number, currentValue: CartItem) => {
        return accumulator + parseFloat(currentValue.quantity);
      },
      0
    )
  );

  const isMenuOptionSelected = useCallback(
    (menuOptionType: MenuOptionType) => {
      return menuOptionType == currentSelectedMenuOption;
    },
    [currentSelectedMenuOption]
  );

  return (
    <Fragment>
      <div className="bottomNavigation-root-container">
        <span
          style={{
            backgroundColor: isMenuOptionSelected("Menu") ? "#67833E" : "#FFF",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: "0.4rem",
            borderRadius: 40,
          }}
          onClick={() => {
            props.handleCallBack("Menu");
          }}
        >
          <SpoonIcon /> &nbsp;
          {isMenuOptionSelected("Menu") && (
            <p className="menuOptionText">Menu</p>
          )}
        </span>
        <span
          style={{
            backgroundColor: isMenuOptionSelected("Search")
              ? "#67833E"
              : "#FFF",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: "0.4rem",
            borderRadius: 40,
          }}
          onClick={() => {
            props.handleCallBack("Search");
          }}
        >
          <SearchIconV2 /> &nbsp;
          {isMenuOptionSelected("Search") && (
            <p className="menuOptionText">Search</p>
          )}
        </span>
        <span
          style={{
            backgroundColor: isMenuOptionSelected("Cart") ? "#67833E" : "#FFF",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: "0.4rem",
            borderRadius: 40,
          }}
          onClick={() => {
            props.handleCallBack("Cart");
          }}
        >
          {cartItemsCount > 0 && !isMenuOptionSelected("Cart") && (
            <span
              style={{
                color: "#FFF",
                fontSize: "0.8rem",
                position: "absolute",
                marginLeft: "1rem",
                marginBottom: "1rem",
                backgroundColor: "#67833E",
                padding: "0.2rem",
                width: "0.8rem",
                height: "0.8rem",
                borderRadius: 30,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>{cartItemsCount}</span>
            </span>
          )}
          <ShoppingCartIcon /> &nbsp;
          {isMenuOptionSelected("Cart") && (
            <p className="menuOptionText">Cart</p>
          )}
        </span>
        <span
          style={{
            backgroundColor: isMenuOptionSelected("Order") ? "#67833E" : "#FFF",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            padding: "0.4rem",
            borderRadius: 40,
          }}
          onClick={() => {
            props.handleCallBack("Order");
          }}
        >
          <BakeIcon /> &nbsp;
          {isMenuOptionSelected("Order") && (
            <p className="menuOptionText">Orders</p>
          )}
        </span>
      </div>
    </Fragment>
  );
};

export default BottomNavigation;
